import { QUESTION_FILTER_TYPE } from '../constants/common';

// Some attribute filters nest their response options under options[0];
// SurveyFiltersSegments reads them from there when present.
export const isNestedAttributeFilter = (filter) => Array.isArray(filter?.options?.[0]?.options);

// The /surveys/{id}/filters DTO has no sample id of its own: a question-backed
// filter's options carry the sample's numeric identifier as groupReferenceId.
// Attribute filters that come from the survey data file have no sample.
export const getFilterSampleId = (filter) => {
  if (!filter) return undefined;
  const ownId = filter.id ?? filter.sampleId;
  if (ownId !== undefined && ownId !== null) return ownId;
  const groupReferenceId = filter.options?.find(
    (option) => option.groupReferenceId !== undefined && option.groupReferenceId !== null
  )?.groupReferenceId;
  return groupReferenceId ?? undefined;
};

// hiddenBySampleId maps a sample id to what the survey wizard hid on it:
// ids (sample.Data.hiddenAnswers — answer codes for single-choice filters,
// dimension ids for multi-select ones) and the labels of hidden dimensions.
const isHiddenOption = (option, hidden) =>
  hidden.ids.has(String(option.code)) ||
  (option.referenceId !== undefined &&
    option.referenceId !== null &&
    hidden.ids.has(String(option.referenceId))) ||
  hidden.labels.has(option.description);

// Drops the options hidden in the survey wizard from attribute filters, and
// drops an attribute filter entirely once none of its options are left.
export const removeHiddenAttributeOptions = (filters, hiddenBySampleId) => {
  if (!filters) return filters;
  return filters.reduce((visible, filter) => {
    if (filter.type !== QUESTION_FILTER_TYPE.ATTRIBUTE) return [...visible, filter];
    const entry = hiddenBySampleId?.[getFilterSampleId(filter)];
    if (!entry || ((entry.ids || []).length === 0 && (entry.labels || []).length === 0)) {
      return [...visible, filter];
    }
    const hidden = {
      ids: new Set((entry.ids || []).map(String)),
      labels: new Set(entry.labels || []),
    };
    const isVisible = (option) => !isHiddenOption(option, hidden);

    if (isNestedAttributeFilter(filter)) {
      const [group, ...rest] = filter.options;
      const options = group.options.filter(isVisible);
      if (options.length === 0) return visible;
      return [...visible, { ...filter, options: [{ ...group, options }, ...rest] }];
    }
    const options = filter.options.filter(isVisible);
    if (options.length === 0) return visible;
    return [...visible, { ...filter, options }];
  }, []);
};
